import React, { memo } from 'react'
import Avatar from '../avatar'

const UserMarker = ({ user }) => {
  return (
    <div className="flex flex-col items-center">
      <div
        className="h-7 flex items-center gap-1 p-0.5 bg-blue-700 opacity-80"
        style={{ borderRadius: '0.875rem' }}
      >
        <Avatar
          className="-ml-1"
          user={user}
          size="s"
          showStatus={false}
          theme="bg-orange-500 border border-white"
        />
        <span className="text-sm text-white whitespace-nowrap mr-2">
          {user.name}
        </span>
      </div>
      <div className="border-solid border-4 h-0 w-0 border-x-transparent border-b-transparent border-t-blue-700 opacity-80" />
      <div
        className="w-6 h-3 border border-blue-400 flex justify-center items-center"
        style={{ borderRadius: '50%' }}
      >
        <div
          className="w-2 h-1 border border-blue-700"
          style={{ borderRadius: '50%' }}
        />
      </div>
    </div>
  )
}

export default memo(UserMarker)
